import { maskPhone } from "@/common/helpers/mask.helpers";
import {
  settingAge,
  formatDateNoHours,
} from "../../../../common/helpers/date.helpers";
export function personalIndicatorInfo(indicator) {
  return [
    { id: 1, spanSize: "col-span-1", label: "Nome", value: indicator.name },
    { id: 2, spanSize: "col-span-1", label: "CPF", value: indicator.cpf },
    {
      id: 3,
      spanSize: "col-span-1",
      label: "Telefone",
      value: maskPhone(indicator.whatsapp),
    },
    { id: 4, spanSize: "col-span-1", label: "E-mail", value: indicator.email },
    {
      id: 5,
      spanSize: "col-span-1",
      label: `Data de nascimento (${settingAge(
        formatDateNoHours(indicator.birthDate)
      )} anos)`,
      value: formatDateNoHours(indicator.birthDate),
    },
  ];
}
export function indicatorAddressInfo(indicator) {
  return [
    {
      id: 1,
      spanSize: "col-span-1",
      label: "CEP",
      value: indicator.address?.zipcode,
    },
    {
      id: 2,
      spanSize: "col-span-2",
      label: "Endereço",
      value: indicator.address?.street,
    },
    {
      id: 3,
      spanSize: "col-span-1",
      label: "Número",
      value: indicator.address?.number,
    },
    {
      id: 4,
      spanSize: "col-span-2",
      label: "Complemento",
      value: indicator.address?.complement,
    },
    {
      id: 5,
      spanSize: "col-span-1",
      label: "Estado",
      value: indicator.address?.state,
    },
    {
      id: 6,
      spanSize: "col-span-1",
      label: "Cidade",
      value: indicator.address?.city,
    },
    {
      id: 7,
      spanSize: "col-span-1",
      label: "Bairro",
      value: indicator.address?.district,
    },
  ];
}
export function indicatorDataBankInfo(indicator) {
  return [
    {
      id: 1,
      spanSize: "col-span-3",
      label: "Tipo de transferência",
      value: indicator.dataBank?.typeTransaction,
    },
    {
      id: 2,
      spanSize: "col-span-3",
      label: "Tipo de Chave",
      value: indicator.dataBank?.tipoDeChave,
    },
    {
      id: 3,
      spanSize: "col-span-3",
      label: "Chave Pix registrada",
      value: indicator.dataBank?.chavePix,
    },
  ];
}
